import { createRouter, createWebHistory } from "vue-router";
//import HomeView from "../views/HomeView.vue";

const routes = [
    {
        path: "/tech",
        name: "tech",
        component: () => import("../views/TechView.vue"),
        meta: {
            title: "T-Tech — автоматизация ресторанного бизнеса",
            headerClass: "",
            refName: "На главную",
            refTo: "/",
            subscribe: false,
        },
    },
    // {
    //     path: "/tourists",
    //     name: "tourists",
    //     component: HomeView,
    //     meta: {
    //         title: "Сеть ресторанов современной татарской кухни из Казани",
    //         headerClass: "",
    //         refName: "Заказать доставку",
    //         refTo: "/menu",
    //         subscribe: true,
    //     },
    // },
    {
        path: "/stocks",
        name: "stocks",
        component: () => import("../views/StocksView.vue"),
        meta: {
            title: "Актуальные акции. Онлайн-сертификаты на вкусные обеды",
            headerClass: "",
            refName: "Заказать доставку",
            refTo: "/menu",
            subscribe: true,
        },
    },
    {
        path: "/stock/:id",
        name: "stock",
        component: () => import("../views/StockIdView.vue"),
        meta: {
            title: "Акция",
            headerClass: "",
            refName: "Заказать доставку",
            refTo: "/menu",
            back: true,
            subscribe: true,
        },
    },
    {
        path: "/",
        name: "home",
        component: () => import("../views/TouristsNew.vue"),
        meta: {
            title: "«Тюбетей Daily» — неотатарская кухня на каждый день!",
            headerClass: "",
            refName: "Заказать доставку",
            refTo: "/menu",
            subscribe: false,
        },
    },
    {
        path: "/restaraunts",
        name: "restaraunts",
        component: () => import("../views/RestarauntsView.vue"),
        meta: {
            title: "Ждем в наших ресторанах! Все адреса и график работы на сайте",
            headerClass: "_delivery",
            refName: "Заказать доставку",
            refTo: "/menu",
            menuDelivery: true,
            subscribe: true,
        },
    },
    {
        path: "/menu",
        name: "menu",
        component: () => import("../views/MenuView.vue"),
        meta: {
            title: "Заказать фирменную доставку или самовывоз на сайте",
            headerClass: "_delivery",
            refName: "На главную",
            refTo: "/",
            profile: true,
            back: true,
            menuDelivery: true,
            subscribe: true,
        },
    },
    {
        path: "/about-us",
        name: "about-us",
        component: () => import("../views/AboutUsView.vue"),
        meta: {
            title: "Узнайте историю компании «Тюбетей». Группа компаний T-Family",
            headerClass: "",
            refName: "Заказать доставку",
            refTo: "/menu",
            subscribe: true,
        },
    },
    {
        path: "/contacts",
        name: "contacts",
        component: () => import("../views/ContactsView.vue"),
        meta: {
            title: "Оставьте свой отзыв или заявку на сотрудничество",
            headerClass: "",
            refName: "Заказать доставку",
            refTo: "/menu",
            subscribe: true,
        },
    },
    /*{
        path: "/delivery",
        name: "delivery",
        component: () => import("../views/DeliveryView.vue"),
        meta: {
            title: "Условия фирменной доставки любимых блюд от «Тюбетей»",
            headerClass: "_delivery",
            refName: "На главную",
            refTo: "/",
            menuDelivery: true,
            subscribe: true,
        },
    },*/
    {
        path: "/discounts",
        name: "discounts",
        component: () => import("../views/DiscountsView.vue"),
        meta: {
            title: "Промокод на скидку 20% на первый заказ в нашем приложении",
            headerClass: "",
            refName: "Заказать доставку",
            refTo: "/menu",
            subscribe: true,
        },
    },
    {
        path: "/invest",
        name: "invest",
        component: () => import("../views/InvestView.vue"),
        meta: {
            title: "Получите инвестиционное предложение от компании «Тюбетей»",
            headerClass: "",
            refName: "Заказать доставку",
            refTo: "/menu",
            subscribe: false,
        },
    },
    {
        path: "/details",
        name: "details",
        component: () => import("../views/DetailsView.vue"),
        meta: {
            title: "Реквизиты организаций",
            headerClass: "_delivery",
            refName: "На главную",
            refTo: "/",
            subscribe: true,
        },
    },
    {
        path: "/profile",
        name: "profile",
        component: () => import("../views/ProfileView.vue"),
        meta: {
            title: "Профиль",
            headerClass: "_delivery",
            refName: "На главную",
            refTo: "/",
            menuDelivery: true,
            back: true,
            subscribe: true,
        },
    },
    {
        path: "/certificates",
        name: "certificates",
        component: () => import("../views/CertificatesView.vue"),
        meta: {
            title: "Сертификаты электронные — кыстыбургеры настоящие!",
            headerClass: "_certificates",
            refName: "На главную",
            refTo: "/",
            subscribe: true,
        },
    },
    {
        path: "/stock/5",
        name: "combo",
        component: () => import("../views/ComboView.vue"),
        meta: {
            title: "Комбо",
            headerClass: "",
            refName: "Заказать доставку",
            refTo: "/menu",
            back: true,
            subscribe: true,
        },
    },
];
// переадресация старых страниц
routes.push(
    {
        path: "/tourists/",
        redirect: "/",
    },
    {
        path: "/catalog/",
        redirect: "/",
    },
    {
        path: "/search/",
        redirect: "/",
    },
    {
        path: "/cart/",
        redirect: "/",
    },
    {
        path: "/recipes/",
        redirect: "/",
    },
    {
        path: "/master-classes/",
        redirect: "/",
    },
    {
        path: "/iftar/",
        redirect: "/",
    },
    {
        path: "/lk/",
        redirect: "/",
    },
    {
        path: "/public_offer/",
        redirect: "/",
    },
    {
        path: "/recipes/27/",
        redirect: "/",
    },
    {
        path: "/restaurants/",
        redirect: "/restaraunts",
    },
    /*{
        path: "/delivery-terms/",
        redirect: "/delivery",
    },*/
    {
        path: "/download_app",
        redirect: "/discounts",
    },
    {
        path: "/about/",
        redirect: "/about-us",
    },
    {
        path: "/login/",
        redirect: "/profile",
    },
    {
        path: "/jobs/",
        beforeEnter: () => {
            window.location.href = "https://rabota.tubatay.com/";
        },
        name: "jobs",
    },
    {
        path: "/opt/",
        redirect: "/contacts",
    },
    {
        path: "/for-suppliers/",
        redirect: "/contacts",
    },
    {
        path: "/reviews/",
        redirect: "/contacts",
    },
    {
        path: "/requisites/",
        redirect: "/details",
    },
    {
        path: "/menu/sertifikaty-i-podarki",
        redirect: "/certificates",
    },
    {
        path: "/categories/na-universitetskoy",
        redirect: "/menu",
    },
    {
        path: "/menu/supy-1",
        redirect: "/menu",
    },
    {
        path: "/menu/kystyburgery",
        redirect: "/menu",
    },
    {
        path: "/categories/",
        redirect: "/menu",
    },
    {
        path: "/menu/vtorye-blyuda-1",
        redirect: "/menu",
    },
    {
        path: "/menu/vypechka",
        redirect: "/menu",
    },
    {
        path: "/menu/detskoe-menyu-2",
        redirect: "/menu",
    },
    {
        path: "/menu/kombo-1",
        redirect: "/menu",
    },
    {
        path: "/menu/novinki-1",
        redirect: "/menu",
    },
    {
        path: "/menu/deserty",
        redirect: "/menu",
    },
    {
        path: "/menu/supy",
        redirect: "/menu",
    },
    {
        path: "/menu/vtorye-blyuda",
        redirect: "/menu",
    },
    {
        path: "/menu/kurai",
        redirect: "/menu",
    },
    {
        path: "/menu/salaty",
        redirect: "/menu",
    },
    {
        path: "/menu/kombo",
        redirect: "/menu",
    },
    {
        path: "/menu/zavtraki",
        redirect: "/menu",
    },
    {
        path: "/menu/napitki-1",
        redirect: "/menu",
    },
    {
        path: "/menu/iftar-kombo",
        redirect: "/menu",
    },
    {
        path: "/catalog/polufabrikaty",
        redirect: "/menu",
    },
);

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
    linkExactActiveClass: "active",
    scrollBehavior(to) {
        if (to.hash) {
            return { el: to.hash, top: 80 };
        }
        return { top: 0 };
    },
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
});

export default router;
